import type { SchemaCreateComponent } from './schema/schema-create/schema-create.component';
import type { JourneyComponent } from './workspace/journey.component';
import { Routes } from '@angular/router';
import { canActivateAuthRole } from './auth/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./landing/landing.component').then((m) => m.LandingComponent),
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./dashboard/dashboard.component').then(
        (m) => m.DashboardComponent,
      ),
    canActivate: [canActivateAuthRole],
  },
  {
    path: 'relying-parties',
    loadComponent: () =>
      import('./relying-parties/relying-parties-list/relying-parties-list.component').then(
        (m) => m.RelyingPartiesListComponent,
      ),
    canActivate: [canActivateAuthRole],
  },
  {
    path: 'relying-parties/create',
    loadComponent: () =>
      import('./relying-parties/relying-party-create/relying-party-create.component').then(
        (m) => m.RelyingPartyCreateComponent,
      ),
    canActivate: [canActivateAuthRole],
  },
  {
    path: 'catalog',
    loadComponent: () =>
      import('./schema/schema-list/schema-list.component').then(
        (m) => m.SchemaListComponent,
      ),
  },
  {
    path: 'catalog/create',
    loadComponent: () =>
      import('./schema/schema-create/schema-create.component').then(
        (m) => m.SchemaCreateComponent,
      ),
    canDeactivate: [(component: SchemaCreateComponent) => component.canLeave()],
    canActivate: [canActivateAuthRole],
  },
  {
    path: 'catalog/:id',
    loadComponent: () =>
      import('./schema/schema-show/schema-show.component').then(
        (m) => m.SchemaShowComponent,
      ),
  },
  {
    path: 'forbidden',
    loadComponent: () =>
      import('./forbidden/forbidden.component').then(
        (m) => m.ForbiddenComponent,
      ),
  },
  {
    path: 'rp/:rpId',
    canActivate: [canActivateAuthRole],
    children: [
      {
        path: 'issue',
        loadComponent: () =>
          import('./workspace/journey.component').then(
            (m) => m.JourneyComponent,
          ),
        data: { role: 'issuer' },
        canDeactivate: [(component: JourneyComponent) => component.canLeave()],
      },
      {
        path: 'request',
        loadComponent: () =>
          import('./workspace/journey.component').then(
            (m) => m.JourneyComponent,
          ),
        data: { role: 'verifier' },
        canDeactivate: [(component: JourneyComponent) => component.canLeave()],
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./registration-certs/registration-cert-defaults/registration-cert-defaults.component').then(
            (m) => m.RegistrationCertDefaultsComponent,
          ),
      },
      {
        path: '',
        loadComponent: () =>
          import('./relying-parties/relying-party-show/relying-party-show.component').then(
            (m) => m.RelyingPartyShowComponent,
          ),
      },
      {
        path: 'ac',
        children: [
          {
            path: 'create',
            loadComponent: () =>
              import('./access-certs/access-cert-create/access-cert-create.component').then(
                (m) => m.AccessCertCreateComponent,
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./access-certs/access-certs-show/access-certs-show.component').then(
                (m) => m.AccessCertsShowComponent,
              ),
            canActivate: [canActivateAuthRole],
          },
        ],
      },
      {
        path: 'rc',
        children: [
          {
            path: 'defaults',
            loadComponent: () =>
              import('./registration-certs/registration-cert-defaults/registration-cert-defaults.component').then(
                (m) => m.RegistrationCertDefaultsComponent,
              ),
          },
          {
            path: 'create',
            loadComponent: () =>
              import('./registration-certs/registration-cert-create/registration-cert-create.component').then(
                (m) => m.RegistrationCertCreateComponent,
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./registration-certs/registration-cert-show/registration-cert-show.component').then(
                (m) => m.RegistrationCertShowComponent,
              ),
            canActivate: [canActivateAuthRole],
          },
        ],
      },
    ],
  },
];
